<template>
  <div class="pb-6 md:pb-6 shadow-xl bg-white">
      <div v-if="banner">
          <img :src="banner" />
      </div>
    <div
      v-if="false"
      class="relative bg-main-blue rounded py-5 px-8 md:py-5 md:px-5 shadow-2xl overflow-hidden"
    
    >
      <div
        class="absolute right-0 bottom-0 pointer-events-none hidden lg:block"
        aria-hidden="true"
      >
        
      </div>
      <div
        class="relative flex flex-col  justify-between items-center"
      >
        <div class="text-center">
            <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    banner: {
      type:[String,Boolean],
      default: ''
    }
  }
}
</script>
